import {
    SELECT_MEDIA,
    REQUEST_MEDIA,                RECIEVE_MEDIA,
    REQUEST_DELETE_MEDIA,         RECIEVE_DELETE_MEDIA,
                                  RECIEVE_ADD_MEDIA,
    REQUEST_SCENE_REPROCESSING,   RECIEVE_SCENE_REPROCESSING,
    REQUEST_DATASET_REPROCESSING, RECIEVE_DATASET_REPROCESSING,
    REQUEST_MEDIA_REPROCESSING,   RECIEVE_MEDIA_REPROCESSING,
    REQUEST_UPDATE_MEDIA,         RECIEVE_UPDATE_MEDIA,
                                  DESELECT_MEDIA,
    SELECT_ALL_MEDIA,             DESELECT_ALL_MEDIA
} from '../constants/actionTypes';
import { mediaItem } from './mediaItem';

export const sceneMedia = (state = {
    fetchingMedia: false,
    reprocessing: false,
    updating: false,
    reprocessingDatasets: [],
    mediaItems: []
}, action) => {
    switch(action.type) {
        case REQUEST_MEDIA:
            return {
                ...state,
                fetchingMedia: true
            };

        case RECIEVE_MEDIA:
            return {
                ...state,
                mediaItems: action.cleanup
                    ? state.mediaItems      // If we are cleaning up, then the action media items are wrong. Use the existing.
                    : action.mediaItems,    // Otherwise use the ones from the action.
                fetchingMedia: false
            };

        case RECIEVE_DELETE_MEDIA:
            return {
                ...state,
                mediaItems: action.cleanup
                    ? state.mediaItems.map(m => (m.sceneMediaID === action.sceneMediaID) ? mediaItem(m, action) : m) // Need to call the media sub reducer to handle unsetting the delete
                    : state.mediaItems.filter(m => m.sceneMediaID !== action.sceneMediaID)                           // Otherwise, remove the item
            };
        
        case REQUEST_DATASET_REPROCESSING:
            return {
                ...state,
                reprocessingDatasets: [action.dataset, ...state.reprocessingDatasets]
            };

        case RECIEVE_DATASET_REPROCESSING:
            return {
                ...state,
                reprocessingDatasets: state.reprocessingDatasets.filter(ds => ds !== action.dataset)
            };

        case REQUEST_SCENE_REPROCESSING:
            return {
                ...state,
                reprocessing: true
            };

        case RECIEVE_SCENE_REPROCESSING:
            return {
                ...state,
                reprocessing: false
            };
        
        case SELECT_ALL_MEDIA:
        case DESELECT_ALL_MEDIA:
            return {
                ...state,
                mediaItems: state.mediaItems.map(m => action.mediaItems.some(item => item.sceneMediaID === m.sceneMediaID) ? mediaItem(m, action) : m)
            };

        case RECIEVE_ADD_MEDIA:
            return {
                ...state,
                mediaItems: action.cleanup
                    ? state.mediaItems                          // If its a cleanup then there is nothing to add
                    : [...state.mediaItems, action.addedMedia]  // Otherwise add the dang thing
            };

        // Use a media item sub-reducer so we dont have to dig up the media item ALL. THE. TIME.
        case SELECT_MEDIA:
        case DESELECT_MEDIA:
        case REQUEST_DELETE_MEDIA:
        case REQUEST_MEDIA_REPROCESSING:
        case RECIEVE_MEDIA_REPROCESSING:
        case REQUEST_UPDATE_MEDIA:
        case RECIEVE_UPDATE_MEDIA:
            return {
                ...state,
                mediaItems: state.mediaItems.map(m => (m.sceneMediaID === action.sceneMediaID) ? mediaItem(m, action) : m)
            };
        
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/sceneMedia.js